module.exports = __webpack_public_path__ + "img/chain_logo_big.678c4940.png";